import React from "react";
import styled from "styled-components";

import Contactbanner from "../../components/Sections/team/teambg.jpg";
import syedAli from "../../components/Sections/team/aliimg.png";
import aliHamza from "../../components/Sections/team/hamzaimg.png";
import aliAhson from "../../components/Sections/team/aliahsonimg.png";
import nabeelJaved from "../../components/Sections/team/nabeel.png";
import malikImran from "../../components/Sections/team/maniimg.png";
import faizanKaramat from "../../components/Sections/team/faizanimg.png";
import tayybaSaveera from "../../components/Sections/team/tayybaimg.png";
import sanwal from "../../components/Sections/team/sanwalimg.png";
import tanveer from "../../components/Sections/team/tanveer.png";
import hammad from "../../components/Sections/team/hammadprof.png"

import abdullahMalik from "../../components/Sections/team/abmalikimg.png"; 

// Team members data
const teamMembers = [
  {
    name: "Abdullah Malik",
    role: "Founder & CEO",
    image: abdullahMalik,
    bio: "Abdullah Malik is a visionary software engineer and founder, dedicated to turning innovative ideas into groundbreaking solutions. His leadership and technical expertise drive the company’s mission to create software that shapes the future.",
    isFounder: true, // Added flag to differentiate the founder
  },

  {
    name: "Sanwal Khan",
    role: "Backend Developer",
    image: sanwal,
    bio: "Sanwal leverages his expertise in backend development to build robust and scalable server-side solutions. His work ensures seamless functionality with user satisfaction."
  },

  {
    "name": "Muhammad Tanveer",
    "role": " Digital Marketing Specialist",
    "image": tanveer,
    "bio": "Google-certified AdWords professional with a proven track record of managing over $400K in ad spend. High-performing campaigns, driving exceptional results for businesses."
},
{
    name: "Hammad Abbas",
    role: "Full Stack Agentic Engineer",
    image: hammad,
    bio: "Hammad specializes in full-stack development and autonomous Agentic AI workflows, bridging the gap between web architecture and intelligent automation. He is an expert in researching and building multi-agent systems that plan, execute, and optimize complex digital tasks with minimal intervention."
  },
  {
    name: "Ali Hamza",
    role: "Web Developer & AI Specialist",
    image: aliHamza,
    bio: "Ali combines his expertise in web development and AI to craft innovative solutions that push the boundaries of technology. His work bridges the gap between functionality and creativity."
  },
  {
    name: "Nabeel Javed",
    role: "Blockchain Developer",
    image: nabeelJaved,
    bio: "Nabeel specializes in blockchain development and smart contract creation, providing decentralized solutions. His expertise is key to building the future of digital transactions."
  },
  {
    name: "Tayyba Saveera",
    role: "Full Stack Developer",
    image: tayybaSaveera,
    bio: "Tayyba excels at both front-end and back-end development, crafting dynamic and scalable applications. She brings a comprehensive approach to development, ensuring seamless functionality."
  },


  {
    name: "Faizan Karamat",
    role: "AI & Machine Learning Specialist",
    image: faizanKaramat,
    bio: "Faizan is a passionate AI and machine learning expert focused on developing innovative, data-driven solutions. He aims to enhance automation and optimize performance in every project."
  },
  {
    name: "Malik Imran",
    role: "UI/UX Designer",
    image: malikImran,
    bio: "Malik’s design philosophy centers on creating clean, intuitive, and user-friendly interfaces. His keen eye for detail ensures that every design is both functional and visually appealing."
  },
  
    

    {
      name: "Muhammad Ali Ahson",
      role: "Data Scientist",
      image: aliAhson,
      bio: "Ali is a skilled data scientist who harnesses the power of machine learning and data analysis to uncover valuable insights from complex datasets."
       },
  
  {
    name: "Syed Muhammad Ali",
    role: "Mobile App Developer",
    image: syedAli,
    bio: "Syed is an experienced mobile app developer with a passion for creating seamless apps for iOS and Android. He’s focused on delivering intuitive, user-centric mobile experiences."
  },
  
  
  
];

// Styled Components
const PageContainer = styled.div`
  padding: 80px 20px;
  text-align: center;
  background-color: #f9f9f9;
`;

const Title = styled.h1`
  font-size: 3rem;
  color: #003366;
  margin-bottom: 50px;
  text-transform: uppercase;
`;

const TeamGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
`;

const TeamMember = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 48%;
  margin-bottom: 40px;
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    text-align: center;
  }

  ${(props) => props.isFounder && `
    width: 100%;
    margin-bottom: 60px;
    justify-content: center;
  `}
`;

// Profile Image Styling
const ProfileImage = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 30px;
  border: 4px solid #0096c7;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);

  // Special styling for Founder
  ${(props) => props.isFounder && `
    border: 4px solid #001f54;
    width: 220px;
  height: 220px;
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.5);  // Changed to black shadow
    transform: scale(1.1);
  `}

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 15px;
  }
`;

const MemberInfo = styled.div`
  flex: 1;
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Name = styled.h2`
  font-size: 1.5rem;
  color: #003366;
  font-weight: 600;
  margin: 10px 0;
`;

const Role = styled.h3`
  font-size: 1.1rem;
  color: #006699;
  font-weight: 400;
  margin-bottom: 10px;
`;

const Bio = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin-bottom: 10px;
`;

const HeaderBanner = styled.header`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background: rgba(0, 0, 0, 0.5);

  @media (max-width: 768px) {
    text-align: center;
    h1 {
      font-size: 2rem;
    }
    h2 {
      font-size: 1.2rem;
    }
  }
`;

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  z-index: -1;
`;

const BannerContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;

  h1 {
    font-size: 4.5rem;
    font-weight: 700;
    color: white;
    text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.7);
  }

  h2 {
    font-size: 1.6rem;
    margin-top: 20px;
    color: #ddd;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
    }
    h2 {
      font-size: 1.3rem;
    }
  }
`;

const TeamPage = () => {
  return (
    <>
      <HeaderBanner id="home">
        <BackgroundImage src={Contactbanner} />
        <BannerContent>
  <h1>Meet Our Team</h1>
  <h2>Our talented team is the driving force behind our success. </h2>
</BannerContent>

      </HeaderBanner>
      <PageContainer>
        <Title>Meet Our Team</Title>
        <br />
        <br />
        <br />
        <TeamGrid>
          {teamMembers.map((member, index) => (
            <TeamMember key={index} isFounder={member.isFounder}>
              <ProfileImage src={member.image} alt={`${member.name}'s profile`} isFounder={member.isFounder} />
              <MemberInfo>
                <Name>{member.name}</Name>
                <Role>{member.role}</Role>
                <Bio>{member.bio}</Bio>
              </MemberInfo>
            </TeamMember>
          ))}
        </TeamGrid>
      </PageContainer>
    </>
  );
};

export default TeamPage;
